import { Constants } from "./../constants";
import { GenericScreenController } from "./generic-screen-controller";
import { IScreenStatusCommand } from "./../screen-status-command";
import { RadiobuttonScreenController } from "./radiobutton-screen-controller";
import { NavigationBarManager } from "../navigation-bar-manager";

/**
 * Workflow Controller for screen 3 with custom logic
 */
export class Screen3Controller extends RadiobuttonScreenController {

    constructor(index: number, navigationBarManager: NavigationBarManager) {
        super(index, navigationBarManager);
        this.isActiveInTheFlow = true;
        this.navigationStatus = {
            showCloseApp: false,
            showExit: false,
            showNext: true,
            showPrevious: false,
            showStartOver: false,
            progressBarGroupIndex: Constants.GROUP_INDEX_1
        };
    }

    public calculateNextScreensInFlow(): Array<IScreenStatusCommand> {
        let visibilityChangeRequest: Array<IScreenStatusCommand> = new Array<IScreenStatusCommand>();
        let selectedOption = this.screenDomElement.find(`.FormChoice__Input.FormChoice__Input--Radio:checked`).val();

        switch (selectedOption) {
            case Constants.YES_1:
                visibilityChangeRequest.push({
                    targetScreenIndex: Constants.SCREEN_6,
                    active: true
                });
                break;

            case Constants.YES_2:
                visibilityChangeRequest.push({
                    targetScreenIndex: Constants.SCREEN_15,
                    active: true
                });
                break;

            case Constants.NO:
                visibilityChangeRequest.push({
                    targetScreenIndex: Constants.SCREEN_9,
                    active: true
                });
                break;
        }

        return visibilityChangeRequest;
    }
}